import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';

import { LoaderEvent } from '../message.event';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';


@Component({
  selector: 'shared-modal',
  templateUrl: './shared-popup.component.html',
  styleUrls: ['./shared-popup.component.css'],
  providers: [LoaderEvent],
  exportAs: 'popUpObj'
})
export class SharedPopupComponent implements OnInit {
  @ViewChild('childModal') childModal: ModalDirective;
  private stringConstants = CONSTANT_MESSAGES;
  @Input() message = '';
  @Input() popupTitle = '';
  @Input() cancleButton;
  @Output() notify = new EventEmitter<boolean>();
  @Output() notifyDelete = new EventEmitter<boolean>();
  @Input() deleteMessage;
  @Input() tempFacilityId;
  @Input() deleteBooking;
  @Input() isActivityChargable = false;
  @Input() bookingConfirmation = false;
  public onsamePage = 0;
  @Output() facilityid = new EventEmitter<string>();
  @Output() showInvoice = new EventEmitter<boolean>();
  public vendor;
  public showPaymentButtons = false;
  private utilityFunctions = new UtilityFunctions();
  constructor(public router: Router, private loaderEvent: LoaderEvent) { }

  ngOnInit() {
  }

  public showChildModal(flag): void {
    try {
      this.onsamePage = flag;
      this.childModal.config.backdrop = false;
      this.childModal.config.keyboard = false;
      if (localStorage.getItem('vendor')) {
        this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
        this.showPaymentButtons = this.vendor.allowPayment;
      }
      this.utilityFunctions.setBackGroundBlack();
      this.childModal.show();
    } catch (e) {
      console.log(e);
    }
  }

  public hideChildModal(): void {
    try {
      this.popupTitle = '';
      this.utilityFunctions.removeBackGroundBlack();
      this.childModal.hide();
    } catch (e) {
      console.log(e);
    }
  }

  onClickOk() {
    try {
      if (!this.onsamePage) {
        this.notify.emit(true);
      }
      if (this.tempFacilityId) {
        this.facilityid.emit(this.tempFacilityId);
      }
    } catch (e) {
      console.log(e);
    }
  }

  onClickCancle() {
    try {
      this.notify.emit(false);
    } catch (e) {
      console.log(e);
    }
  }
  payNow() {
    this.utilityFunctions.removeBackGroundBlack();
    this.showInvoice.emit(true);
    this.popupTitle = '';
    this.childModal.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared-popup/shared-popup.component.ts